export const SECTION_SPACING_IN_REM = 4;
